export default {
  'userandregister.login.userName': '賬戶',
  'userandregister.login.password': '密碼',
  'userandregister.login.message-invalid-credentials': '賬戶或密碼錯誤（admin/ant.design）',
  'userandregister.login.message-invalid-verification-code': '驗證碼錯誤',
  'userandregister.login.tab-login-credentials': '賬戶密碼登錄',
  'userandregister.login.tab-login-mobile': '手機號登錄',
  'userandregister.login.remember-me': '自動登錄',
  'userandregister.login.forgot-password': '忘記密碼',
  'userandregister.login.sign-in-with': '其他登錄方式',
  'userandregister.login.signup': '註冊賬戶',
  'userandregister.login.login': '登錄',
  'userandregister.register.register': '註冊',
  'userandregister.register.get-verification-code': '獲取驗證碼',
  'userandregister.register.sign-in': '使用已有賬戶登錄',
  'userandregister.register-result.msg': '妳的賬戶：{email} 註冊成功',
  'userandregister.register-result.activation-email':
    '激活郵件已發送到妳的郵箱中，郵件有效期為24小時。請及時登錄郵箱，點擊郵件中的鏈接激活帳戶。',
  'userandregister.register-result.back-home': '返回首頁',
  'userandregister.register-result.view-mailbox': '查看郵箱',
  'userandregister.email.required': '請輸入郵箱地址！',
  'userandregister.email.wrong-format': '郵箱地址格式錯誤！',
  'userandregister.userName.required': '請輸入賬戶!',
  'userandregister.password.required': '請輸入密碼！',
  'userandregister.password.twice': '兩次輸入的密碼不匹配!',
  'userandregister.strength.msg': '請至少輸入 6 個字符。請不要使用容易被猜到的密碼。',
  'userandregister.strength.strong': '強度：強',
  'userandregister.strength.medium': '強度：中',
  'userandregister.strength.short': '強度：太短',
  'userandregister.confirm-password.required': '請確認密碼！',
  'userandregister.phone-number.required': '請輸入手機號！',
  'userandregister.phone-number.wrong-format': '手機號格式錯誤！',
  'userandregister.verification-code.required': '請輸入驗證碼！',
  'userandregister.title.required': '請輸入標題',
  'userandregister.date.required': '請選擇起止日期',
  'userandregister.goal.required': '請輸入目標描述',
  'userandregister.standard.required': '請輸入衡量標淮',
  'userandregister.form.get-captcha': '獲取驗證碼',
  'userandregister.captcha.second': '秒',
  'userandregister.form.optional': '（選填）',
  'userandregister.form.submit': '提交',
  'userandregister.form.save': '保存',
  'userandregister.email.placeholder': '郵箱',
  'userandregister.password.placeholder': '至少6位密碼，區分大小寫',
  'userandregister.confirm-password.placeholder': '確認密碼',
  'userandregister.phone-number.placeholder': '手機號',
  'userandregister.verification-code.placeholder': '驗證碼',
  'userandregister.title.label': '標題',
  'userandregister.title.placeholder': '給目標起個名字',
  'userandregister.date.label': '起止日期',
  'userandregister.placeholder.start': '開始日期',
  'userandregister.placeholder.end': '結束日期',
  'userandregister.goal.label': '目標描述',
  'userandregister.goal.placeholder': '請輸入妳的階段性工作目標',
  'userandregister.standard.label': '衡量標淮',
  'userandregister.standard.placeholder': '請輸入衡量標淮',
  'userandregister.client.label': '客戶',
  'userandregister.label.tooltip': '目標的服務對象',
  'userandregister.client.placeholder': '請描述妳服務的客戶，內部客戶直接 @姓名／工號',
  'userandregister.invites.label': '邀評人',
  'userandregister.invites.placeholder': '請直接 @姓名／工號，最多可邀請 5 人',
  'userandregister.weight.label': '權重',
  'userandregister.weight.placeholder': '請輸入',
  'userandregister.public.label': '目標公開',
  'userandregister.label.help': '客戶、邀評人默認被分享',
  'userandregister.radio.public': '公開',
  'userandregister.radio.partially-public': '部分公開',
  'userandregister.radio.private': '不公開',
  'userandregister.publicUsers.placeholder': '公開給',
  'userandregister.option.A': '同事甲',
  'userandregister.option.B': '同事乙',
  'userandregister.option.C': '同事丙',
  'userandregister.navBar.lang': '語言',
};
